/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";

/** CSS Files */
import "./Organizationlocation.scss";

/** Common Components */
import SidebarModel from "../../../components/ui/sidebarModel/SidebarModel";
import Buttons from "../../../components/ui/button/Buttons";
import Iconify from "../../../layouts/components/iconify/iconify";
import ToggleButton from "../../../components/finalForms/ui/inputs/toggleButton/ToggleButton";
import { DropdownWrapper } from "../../../components/ui/dropdownwrapper/DropdownWrapper";

/** Common Services & Data Files */
import SwalAlert from "../../../services/swalService/SwalService";
import ToastService from "../../../services/toastService/ToastService";

/** RTK Query */
import {
  useDeleteOrganizationLocationMutation,
  useLazyGetAllOrganizationLocationQuery,
  useUpdateOrganizationLocationMutation
} from "../../../app/services/organizationAPI";

/** Lazily Loaded Components */
import AddOrganizationLocation from "../organizationAddress/AddOrganizationLocation";

const OrganizationLocation = () => {

  const { confirm } = SwalAlert();
  
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(null);

  const [organizationLocationList, setOrganizationLocationList] = useState([]);

  const [getAllOrganizationLocation, {
    isLoading: isOrgLoading,
    isFetching: isOrgFetching,
    isSuccess: isOrgSuccess,
    data: orgLocations
  }] = useLazyGetAllOrganizationLocationQuery();

  const [deleteOrganizationLocation, {
    isSuccess: isDeleteSuccess,
    isLoading: isDeleting,
    data: deletedLocation
  }] = useDeleteOrganizationLocationMutation();

  const [updateOrganizationLocation, {
    isSuccess: isupdateLocationSuccess,
    data: UpdateLocationData
  }] = useUpdateOrganizationLocationMutation();

  useEffect(() => {
    getAllOrganizationLocation();
  }, [getAllOrganizationLocation]);

  useEffect(() => {
    if (isupdateLocationSuccess && UpdateLocationData) {
      if (UpdateLocationData.errorMessage.includes("exists")) {
        ToastService.warning(UpdateLocationData.errorMessage);
        return;
      } else {
        ToastService.success(UpdateLocationData.errorMessage);
        getAllOrganizationLocation();
      }
    }
  }, [isupdateLocationSuccess, UpdateLocationData]);

  useEffect(() => {
    if (isDeleteSuccess && deletedLocation) {
      if (deletedLocation.errorMessage.includes("exists")) {
        ToastService.warning(deletedLocation.errorMessage);
      } else {
        ToastService.success(deletedLocation.errorMessage);
        getAllOrganizationLocation();
      }
    }
  }, [isDeleteSuccess, deletedLocation]);

  useEffect(() => {
    if (!isOrgFetching && isOrgSuccess && orgLocations) {
      setOrganizationLocationList(orgLocations);
    }
  }, [isOrgFetching, isOrgSuccess, orgLocations]);

  const handleOpenSidebar = (locationId) => {
    setSelectedId(locationId);
    setIsSidebarOpen(true);
  };

  const handleDelete = (locationId) => {
    confirm(
      "Delete?",
      "Are you sure you want to Delete?",
      "Delete",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        deleteOrganizationLocation(locationId);
      }
    });
  };

  const handleCloseSidebar = () => {
    setIsSidebarOpen(false);
    setSelectedId(null);
  };

  const handleToggle = (item) => {
    confirm(
      "Confirm Update",
      `Are you sure you want to ${item.isPrimary ? "disable" : "enable"
      } this location as primary?`,
      "Yes, Update",
      "Cancel"
    ).then((confirmed) => {
      if (confirmed) {
        const updatedItem = { ...item, isPrimary: !item.isPrimary };
        updateOrganizationLocation(updatedItem);
        getAllOrganizationLocation();
      }
    });
  };

  return (
    <div>
      <div className="card-subsection-org-body">
        <div className="add-address">
          <div className="add-address-title">Locations</div>
          <Buttons
            buttonTypeClassName="theme-btn"
            buttonText="Add Location"
            onClick={() => handleOpenSidebar(null)}
            textWithIcon={true}
            fontIcon={true}
            iconName="ic:round-add"
          />
        </div>
        <div className="row address-group">
          {organizationLocationList?.map((item, index) => (
            <div className="col-12" key={item.id}>
              <div className="org-subcard">
                <div isContentLoading={isDeleting || isOrgLoading}>
                  <div className="address-card">
                    <div className="address-header">
                      <div
                        className={`isprimary-chip ${item.isPrimary ? "primary" : "not-primary"
                          }`}
                      >
                        {item.isPrimary ? (
                          <div>Primary</div>
                        ) : (
                          <div>Not Primary</div>
                        )}
                      </div>
                      {organizationLocationList.length > 1 && (
                        <ToggleButton
                          value="check"
                          selected={item.isPrimary}
                          isChecked={item.isPrimary}
                          onChange={() => handleToggle(item)}
                          isdisable={item.isPrimary}
                        >
                          {" "}
                        </ToggleButton>
                      )}
                    </div>
                    <div
                      className="d-flex justify-content-between"
                      style={{ padding: "10px 15px" }}
                    >
                      <div className="address-content">
                        <span className="font-bold">{item.addressLine1}</span>
                        <span>{item.addressLine2}</span>
                        <span>
                          {item.city}, {item.state}, {item.country}
                        </span>
                      </div>
                      <div className="address-actions">
                        <DropdownWrapper
                          direction="left"
                          className="action-button-dropdown"
                          closeOnSelect={true}
                          toggleElement={
                            <button className="customer-more-btn">
                              <Iconify icon="humbleicons:dots-vertical" />
                            </button>
                          }
                        >
                          <button
                            onClick={() => handleOpenSidebar(item.locationId)}
                          >
                            <Iconify icon="line-md:pencil" />
                            Edit
                          </button>
                          {!item.isPrimary && (
                            <button onClick={() => handleDelete(item.locationId)}>
                              <Iconify icon="mingcute:delete-2-line" />
                              Delete
                            </button>
                          )}
                        </DropdownWrapper>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
        <SidebarModel
          isOpen={isSidebarOpen}
          onClose={handleCloseSidebar}
          modalTitle={
            selectedId
              ? "Update Organization Location"
              : "Add Organization Location"
          }
          modalSize="w-40"
        >
          <AddOrganizationLocation
            onSidebarClose={handleCloseSidebar}
            isOpen={isSidebarOpen}
            selectedId={selectedId}
          />
        </SidebarModel>
      </div>
    </div>
  );
};

export default OrganizationLocation;
